<template>
    <div class="detail">
        <div class="header">
            <div class="left" @click="toIndex()">< 返回</div>
            <div class="span1">
                <span>{{info.name}} 课程考勤统计</span>
            </div>
            <div class="right"></div>
        </div>
        <div>
            <el-form ref="form" :inline="true" :model="form" label-width="90px">
            <el-form-item label="">
              <el-select
                v-model="form.a"
                placeholder="请选择学年学期"
              >
                <el-option
                  v-for="item in TKoptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="">
              <el-input
                v-model="form.c"
                clearable
                placeholder="请输入课程名称"
              />
            </el-form-item>
            <el-form-item label="">
              <el-date-picker
                v-model="form.d"
                style="width: 300px; margin-top: 4px"
                type="daterange"
                range-separator="~"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="">
              <el-button type="primary" @click="searchFun">搜索</el-button>
            </el-form-item>
          </el-form>

            <!-- 校内教师 -->
            <div class="table">
                <el-table :data="tableData" style="width: 100%">
                    <el-table-column prop="name" label="课程名称" align="center">
                    </el-table-column>
                    <el-table-column prop="nj" label="授课教师" align="center">
                    </el-table-column>
                    <el-table-column prop="kc" label="总课时数" align="center">
                    </el-table-column>
                    <el-table-column prop="sj" label="应出勤次数" align="center">
                    </el-table-column>
					<el-table-column prop="yj" label="实际出勤次数" align="center">
                    </el-table-column>
					<el-table-column prop="yj" label="出勤率" align="center">
                    </el-table-column>
                </el-table>
                <div class="pagination">
                    <el-pagination background :current-page="pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage" layout="total,prev, pager, next,jumper,sizes" @size-change="sizeChangeHandle"
                        @current-change="currentChangeHandle"></el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props:['info'],
	data() {
		return {
			pageNum: 1,
			pageSize: 10,
			totalPage: 20,
			form: {
				input: '',
				classificationId: '',
				a: '',
				b: '',
				c: '',
				d: ''
			},

			ResourceList2: [
				{ label: '2019-2020学年', id: '1' },
				{ label: '2020-2021学年', id: '2' },
				{ label: '2021-2022学年', id: '3' }
			],

			ResourceList: [
				{ label: '一年级4班', id: '1' },
				{ label: '一年级3班', id: '2' },
				{ label: '一年级5班', id: '3' }
			],
			tableData: [
				{
					name: '宋天睿',
					nj: '一年级4班',
					kc: '初级围棋',
					sj: '2021/09/1  10:16',
					yj: '￥100.00',
					zt: '已付款'
				},
				{
					name: '冯易梦',
					nj: '一年级3班',
					kc: '世界百科课',
					sj: '2021/09/8  10:20',
					yj: '￥100.00',
					zt: '已付款'
				},
				{
					name: '萧楚洁',
					nj: '一年级5班',
					kc: '体适能课',
					sj: '2021/09/1  10:16',
					yj: '￥100.00',
					zt: '已付款'
				},
				{
					name: '龚瑜然',
					nj: '一年级4班',
					kc: '初级围棋',
					sj: '2021/09/1  10:08',
					yj: '￥100.00',
					zt: '已付款'
				},
				{
					name: '段惜霜',
					nj: '一年级6班',
					kc: '世界百科课',
					sj: '2021/09/1  10:18',
					yj: '￥100.00',
					zt: '已付款'
				},
			]
		}
	},
	created() {},
	methods: {
		getDataList() {},
		sizeChangeHandle(val) {
			this.pageSize = val

			this.getDataList()
		},

		currentChangeHandle(val) {
			this.pageNum = val
			this.getDataList()
		},

        toIndex(){
            this.$emit('to-index')
        },
	},
	mounted() {},
	watch: {}
}
</script>
<style lang="less" scoped>
.detail {
	width: 100%;
    padding: 0px 30px 30px 30px;
	.header {
		height: 60px;
		line-height: 48px;
		margin-bottom: 20px;
		display: flex;
		justify-content: space-between;
        align-items: center;
		.span1 {
			font-family: 'PingFang SC Bold';
			font-size: 20px;
			color: #000;
			margin-right: 30px;
		}
        .left, .right{
            width: 60px;
        }
        .left{
            cursor: pointer;
        }
	}

	::v-deep .el-form .el-input__inner {
		width: 150px;
		height: 32px;
		border-radius: 3px;
		background: #fff;
		border: 1px solid #ddd;
	}

	::v-deep .el-table__header tr th {
		background: #f7f7f7;
		box-shadow: 0px 1px 0px #eaeaea;
	}

    ::v-deep .el-date-editor .el-range-separator{
        line-height: 22px;
    }

	.pagination {
		text-align: center;
		margin-top: 30px;
	}
}
</style>
